// install (please try to align the version of installed @nivo packages)
// yarn add @nivo/bar
import { ResponsiveBar } from "@nivo/bar";
import { useEffect, useMemo, useState } from "react";
import { useWindowSize } from "../../../global/hooks/viewportHooks";
import { fetchV1HistoryEndPoint } from "../../../configuration";
import { getRandomUUID } from "../../../Token";
import { UpdateDisabled } from "@mui/icons-material";
import useFetch from "../../../global/hooks/useFetchHooks";
import { useSelector } from "react-redux";

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
export const data = [
  {
    x: "06/05 16:00",
    y: 24.22,
  },
  {
    x: "06/05 18:00",
    y: 23.79,
  },
  {
    x: "06/05 20:00",
    y: 23.81,
  },
  {
    x: "06/05 22:00",
    y: 23.76,
  },
  {
    x: "06/06 00:00",
    y: 24.39,
  },
  {
    x: "06/06 02:00",
    y: 25.27,
  },
  {
    x: "06/06 04:00",
    y: 25.77,
  },
  {
    x: "06/06 06:00",
    y: 26.06,
  },
  {
    x: "06/06 08:00",
    y: 26.21,
  },
  {
    x: "06/06 10:00",
    y: 24.36,
  },
  {
    x: "06/06 12:00",
    y: 23.69,
  },
  {
    x: "06/06 14:00",
    y: 23.7,
  },
  {
    x: "06/06 16:00",
    y: 23.65,
  },
  {
    x: "06/06 18:00",
    y: 23.67,
  },
  {
    x: "06/06 20:00",
    y: 23.59,
  },
  {
    x: "06/06 22:00",
    y: 23.68,
  },
  {
    x: "06/07 00:00",
    y: 23.9,
  },
];

export const MyResponsiveBar = ({
  finalKeys,
  sensorData,
  legend,
  ble,
  lora,
  setLastUpdatedReading,
}) => {
  let tempWidth = useWindowSize();
  let width = tempWidth.width;
  //Groupby function
  let fieldQuery = legend;
  legend = legend === "Supervisory" ? "BatteryLevel" : legend;

  const dummyData = [
    {
      x: "",
      y: 0,
    },
  ];
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  const [deviceData, setDeviceData] = useState(dummyData);
  const [minDate, setMinDate] = useState();
  const [maxDate, setMaxDate] = useState();

  // console.log("ruleList", sessionStorage.getItem("ruleList"))

  // console.log("sensor data in SensorLineChart",sensorData.data )
  // console.log("fields in sensorData", sensorData.fields)
  //Extract fields needed in order to call event field history line chart
  let deviceId = sensorData.data.uid;
  // console.log("deviceId in SensorLineChartV1", deviceId)
  // console.log("finalKeys in LineChartUI", finalKeys)

  //   }
  // }, [])

  let { data: response } = useFetch(fetchV1HistoryEndPoint(fieldQuery), {
    method: "POST",
    body: JSON.stringify({
      accountname: activeSession.accountId,
      resourceidentifier: {
        deviceid: deviceId,
      },
    }),
    filter: {
      $nopagination: true,
    },
  });

  useEffect(() => {
    if (response?.error) {
      if (
        response.error_description ===
        "Invalid token type in Authorization header."
      ) {
        alert("Invalid Token, Please login first");
        return;
      } else if (response.error === "unauthorized_client") {
        alert(
          "This user is not authorized to fetch device list, please log in as device user"
        );
        return;
      }
    }
    console.log("response from device history", response);
    response = lora
      ? response?.map((resp, key) => {
        let returnVal = {
          createdon: resp.createdon,
          fields: {
            [legend]: resp.fields.Supervisory.BatteryLevel.split(",")[0],
          },
        };

        console.log("resp finalPayload", returnVal);
        return returnVal;
      })
      : response;
    const compData = showEveryDataPoint(
      response,
      fieldQuery === "Supervisory" ? "BatteryLevel" : fieldQuery,
      sensorData,
      ble,
      lora
    );
    console.log("compData", compData);
    // //if (deviceData != compDataInitial)
    setDeviceData(compData);
    //parsing logic goes here
    //after getting response logic to parse the data and prepare for line chart
    setMinDate(compData[0]?.x);
    setMaxDate(compData[compData.length - 1]?.x);
    setLastUpdatedReading(compData[compData.length - 1]?.x);
  }, [
    response,
    fieldQuery,
    sensorData,
    ble,
    lora,
    legend,
    setLastUpdatedReading,
  ]);

  return (
    <ResponsiveBar
      theme={{
        legends: {
          text: {
            fontSize: 15,
          },
        },
        axis: {
          legend: {
            text: {
              fontSize: 19,
            },
          },
          ticks: {
            text: {
              fontSize: 14,
            },
          },
        },
      }}
      data={deviceData === undefined ? [] : deviceData}
      maxValue={100}
      keys={["y"]}
      indexBy="x"
      margin={{ top: 10, right: 200, bottom: 85, left: 200 }}
      padding={0.4}
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      colors={"gray"}
      borderColor={{
        from: "color",
        modifiers: [["darker"]],
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickRotation: 0,
        legend: "Time",
        legendPosition: "middle",
        legendOffset: 43,
        renderTick: ({ textX, textY, value, x, y }) => {
          if (!(value === minDate || value === maxDate)) return "";
          let [val1, val2] = value.split(" ");
          if (new Date(value) === "Invalid Date") {
            [val1, val2] = new Date(value.trim())
              .toLocaleString([], { hour12: true })
              .split(", ");
          }

          return (
            <>
              <g transform={`translate(${x - 30},${y})`}>
                <text transform={`translate(${textX},${textY + 15})`}>
                  {val1}
                </text>
              </g>
              <g transform={`translate(${x - 30},${y})`}>
                <text transform={`translate(${textX},${textY + 30})`}>
                  {val2}
                </text>
              </g>
            </>
          );
        },
        tickPadding: 2,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "Battery",
        legendPosition: "middle",
        legendOffset: -50,
        max: 100,
      }}
      label={"none"}
    />
  );
};

function groupBy_Date() {
  return function (xs, key) {
    // console.log(xs, key);
    if (xs) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x["y"]);
        return rv;
      }, {});
    } else {
    }
  };
}

function showEveryDataPoint(response, fieldQuery, sensorData, ble, lora) {
  let eventHistory = getDateAndFieldValueV1(response, fieldQuery, ble, lora);
  eventHistory = eventHistory?.sort(function (a, b) {
    return -1;
  });
  // console.log("eventHistory", eventHistory);
  // console.log("sensorData in showEveryDataPoint", sensorData)
  let groupByDate = groupBy_Date();
  let groupByDateData = groupByDate(eventHistory, "x");
  // console.log("groupByDateData", groupByDateData);
  let lineChartData = prepareDataForLineChartV1(groupByDateData, ble);
  // console.log("lineChartData", lineChartData);
  //
  const compData = lineChartData;

  return compData;
}

function calculateAverage(array) {
  var total = 0;
  var count = 0;

  array.forEach(function (item, index) {
    let val = item;
    if (typeof item === "string") {
      val = parseInt(item);
    }

    total += val;
    count++;
  });

  return total / count;
}

function prepareDataForLineChartV1(groupByDateData, ble) {
  let finalLineData = [];
  let keys = groupByDateData && Object.keys(groupByDateData);
  //Average function
  // console.log("keys in prepareDataForLineChartV1", keys)

  for (let i = 0; i < keys?.length; i++) {
    //Key is date
    let date = keys[i];
    let field_values = groupByDateData[date];
    // console.log("date key ", date)
    // console.log("field values to be averaged", field_values)
    //Calculating average of field for each date
    let avg = calculateAverage(field_values);
    // console.log("resulting avg", avg)
    //Adding to final data object
    let dateCheck = date.split(" ")[1].split(":")[0];
    //     if (ble){
    //         if (parseInt(dateCheck) % 5 === 0){
    //             finalLineData.push({
    //                 x: date,
    //                 y: Number(avg.toFixed(2)) //Two decimal places
    //             });
    //         }
    // } else {
    //         finalLineData.push({
    //             x: date,
    //             y: Number(avg.toFixed(2)) //Two decimal places
    //         });
    //     }

    finalLineData.push({
      x: date,
      y: Number(avg.toFixed(2)), //Two decimal places
    });
  }
  //Sort data by date
  finalLineData?.sort(function (a, b) {
    var c = new Date(a.x);
    var d = new Date(b.x);
    return c - d;
  });
  // console.log("finalLineData", finalLineData)
  return finalLineData;
}

function timeConvert(time) {
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    time = time.slice(1);
    time[5] = +time[0] < 12 ? "AM" : "PM";
    time[0] = +time[0] % 12 || 12;
  }
  return time.join("");
}

function getDateAndFieldValueV1(eventHistory, field, ble, lora) {
  console.log("eventHistory in getDateAndFieldValueV1", eventHistory);
  return eventHistory?.map((eventData) => {
    // console.log("eventData", eventData);
    let time = eventData.createdon;
    // console.log("time", time);
    // console.log("date time", Date(time));
    // console.log("time.split", time.split("T"));

    let time_vals = time.split("T")[0].split("-");
    let hour = time.split("T")[1].split(":")[0];
    let final_time = hour + ":00";
    let year = time_vals[0];
    let month = time_vals[1];
    let day = time_vals[2];
    let slash = "/";

    let final_date = ble
      ? "".concat(month, slash, day, " ", final_time)
      : "".concat(month, slash, day);

    let realTime = time.split("T")[1].split("Z")[0];
    let updatedTime = realTime.split(":")[0] + ":" + realTime.split(":")[1];
    console.log("updatedTime", updatedTime);
    console.log("final_date", final_date);
    let hopefullyLastFormattedTime = timeConvert(updatedTime);
    let hopefullyLastFormattedTimeNormal = timeConvert(final_time);
    console.log("hopefullyLastFormattedTime", hopefullyLastFormattedTime);
    console.log(
      "hopefullyLastFormattedTimeNormal",
      hopefullyLastFormattedTimeNormal
    );

    let newTime = new Date(time);
    let newnewtime = newTime.toLocaleString("en-US");

    //6/11/2023, 8:25:48 AM
    let timeSplit = newnewtime.split(",");
    let dateSplit = timeSplit[0];

    let splitTime = timeSplit[1].split(" ");
    let hourSplit = splitTime[1].split(":")[0];
    let amPm = splitTime[2];

    let finalTime = "".concat(
      dateSplit,
      ",",
      " ",
      hourSplit,
      ":00:00",
      " ",
      amPm
    );

    console.log("splitTime", splitTime);
    console.log("finalTime", finalTime);

    console.log(final_date);
    console.log(time);

    return {
      x: lora
        ? "".concat(
          month,
          slash,
          day,
          slash,
          year,
          " ",
          hopefullyLastFormattedTime
        )
        : "".concat(finalTime),
      y: lora
        ? parseInt(eventData.fields[field]) >= 3
          ? 100
          : parseFloat(parseFloat(eventData.fields[field]) / 3) * 100
        : eventData.fields[field],
    };
  });
}
